// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ps[data-v-a5987a02] {\n    height: 1200px;\n}\n", ""]);
// Exports
module.exports = exports;
